<app-common-header-layout
  class="common-header-layout"
  [trackingObject]="trackingObject$ | async"
  [trackingScreenName]="trackingScreenName"
>
  <div class="content">
    <i2g-notification
      *ngIf="error$ | async as error"
      class="error-msg"
      notificationStyle="alert"
      [showDismissIcon]="false"
      [isHtmlMessage]="true"
      [message]="error"
    >
    </i2g-notification>

    <div class="content-wrapper">
      <i2g-icon class="validate-prompt-icon" [icon]="validatePromptIcon">
      </i2g-icon>

      <div class="message-wrapper">
        <h1 class="title">{{ 'UNUSUAL_ACTIVITY.TITLE' | translate }}</h1>

        <p class="check-your-inbox">
          {{ 'UNUSUAL_ACTIVITY.CHECK_YOUR_INBOX' | translate }}
        </p>

        <p class="spam-folder">
          {{ 'UNUSUAL_ACTIVITY.SPAM_FOLDER' | translate }}
        </p>

        <button
          *ngIf="challenge$ | async as challenge"
          class="resend-email"
          i2gButton
          buttonStyle="emphasis"
          type="button"
          [disabled]="emailResent$ | async"
          i2gTrackable
          [trackingObject]="trackingObject$ | async"
          [trackingAction]="resendEmailAction"
          [trackingAdditionalProperties]="trackingAdditionalProperties$ | async"
          (click)="resendEmail(challenge.id)"
        >
          {{ 'ACTION.RESEND_EMAIL' | translate }}
        </button>

        <i2g-link
          class="contact-us"
          [inline]="!(challenge$ | async)"
          buttonStyle="tertiary"
          [href]="contactUsUrl"
          [label]="'ACTION.CONTACT_US' | translate"
          [openInNewTab]="true"
          [trackingObject]="trackingObject$ | async"
          [trackingAction]="contactUsAction"
          [trackingAdditionalProperties]="trackingAdditionalProperties$ | async"
        >
        </i2g-link>
      </div>
    </div>
  </div>
</app-common-header-layout>
